export const fr = {
  footer: {
    description: "Une brève description du produit et de sa mission.",
    resources: "Ressources",
    support: "Support",
    legal: "Mentions légales",
    validation: "Validation des Sceaux",
    history: "Historique des Consultations",
    reports: "Rapports et Statistiques",
    geolocation: "Géolocalisation",
    complaint: "Signaler une Irrégularité",
    helpCenter: "Centre d'Aide",
    tutorials: "Tutoriels",
    contact: "Contact",
    faq: "FAQ",
    reportProblem: "Signaler un Problème",
    terms: "Conditions d’Utilisation",
    privacy: "Politique de Confidentialité",
    cookies: "Politique de Cookies",
    licenses: "Licences",
    portal: "Portail",
    copyright: "Tous droits réservés.",
    social: {
      facebook: "Facebook",
      twitter: "Twitter",
      instagram: "Instagram",
      youtube: "YouTube",
    },
  },
  nav: {
    validateSeal: "Valider le sceau",
    howItWorks: "Comment ça marche",
    faq: "Foire Aux Questions (FAQ)",
    reportProblem: "Signaler un problème",
    contact: "Contact",
    menu: "Menu",
    benefits: "Avantages",
    resources: "Ressources",
    queryHistory: "Historique des consultations",
  },
  querysFilter: {
    title: "Filtres",
    description: "Affinez votre recherche à l’aide des filtres ci-dessous.",
    inputPlaceholder: "Recherche par ID",
    dateFilter: {
      all: "Toutes les dates",
      today: "Aujourd’hui",
      lastSevenDays: "Les 7 derniers jours",
      lastThirtyDays: "Les 30 derniers jours",
    },
  },

  contactPage: {
    title: "Contactez-nous",
    subtitle: "Envoyez votre message à notre équipe",
    emailInputLabel: "E-mail",
    phoneInputLabel: "Téléphone (facultatif)",
    messageInputLabel: "Message",
    messageInputPlaceholder: "Écrivez votre message ici...",
    submitButtonText: "Envoyer le message",
    whatsAppButton: "Contactez-nous sur WhatsApp",
  },
  faqPage: {
    title: "Questions Fréquemment Posées",
    subtitle: "Trouvez des réponses aux questions les plus courantes",
    items: [
      {
        question: "Que sont les scellés et comment fonctionnent-ils ?",
        answer:
          "Les scellés sont des étiquettes d’authenticité apposées sur chaque produit. Chaque scellé possède une numérotation unique et séquentielle (ex : 1, 2, 3... jusqu’à 1000), permettant le suivi individuel de chaque produit produit. Cela garantit l’authenticité et un contrôle total de la production.",
      },
      {
        question: "Les scellés peuvent-ils être suivis individuellement ?",
        answer:
          "Oui ! Chaque scellé possède un numéro unique permettant un suivi individuel. Vous pouvez consulter l’historique de n’importe quel scellé, y compris sa création, son utilisation et le produit sur lequel il a été appliqué.",
      },
    ],
  },

  denouncePage: {
    title: "Signaler un Scellé Contrefait",
    subtitle:
      "Aidez-nous à lutter contre la contrefaçon en signalant des scellés suspects",
    imagesRequired: "Veuillez ajouter au moins une image.",
    submittingText: "Envoi en cours...",

    imagesSectionTitle: "Images",

    imagesUploadLabel: "Cliquez ou faites glisser les images ici",
    imagesUploadHint: "PNG, JPG, WEBP jusqu'à 10Mo par image",

    reporterSectionTitle: "Informations du Déclarant",
    sealSectionTitle: "Informations sur le Scellé",
    detailsSectionTitle: "Détails du Signalement",

    nameLabel: "Nom complet",
    namePlaceholder: "Votre nom",

    emailLabel: "E-mail",
    emailPlaceholder: "votre@email.com",

    phoneLabel: "Téléphone (facultatif)",
    phonePlaceholder: "(00) 00000-0000",

    sealCodeLabel: "Code du Scellé",
    sealCodePlaceholder: "Ex : SEAL-2024-XXXX",

    sealTypeLabel: "Type de Scellé",
    sealTypePlaceholder: "Sélectionnez le type",
    sealTypeOptions: {
      holographic: "Holographique",
      other: "Autre",
    },

    brandLabel: "Marque / Fabricant du Produit",
    brandPlaceholder: "Nom de la marque",

    productLabel: "Nom du Produit",
    productPlaceholder: "Nom du produit",

    locationLabel: "Lieu d’Achat / de Découverte",
    locationPlaceholder: "Magasin, ville ou lien du site",

    reasonLabel: "Motif du Signalement",
    reasonPlaceholder: "Sélectionnez le motif",
    reasonOptions: {
      fakeSeal: "Scellé visiblement faux",
      invalidCode: "Code invalide lors de la validation",
      duplicate: "Code dupliqué ou déjà utilisé",
      damaged: "Scellé altéré ou endommagé",
      suspicious: "Produit suspect de contrefaçon",
      other: "Autre motif",
    },

    descriptionLabel: "Description détaillée",
    descriptionPlaceholder:
      "Décrivez en détail les irrégularités observées sur le scellé ou le produit...",

    submitButtonText: "Envoyer le Signalement",
  },

  common: {
    loadingConsultation: "Exécution de la requête pour ce texte en cours",
    cancel: "Annuler",
    confirm: "Confirmer",
    back: "Retour",
    retry: "Réessayer",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    yes: "Oui",
    no: "Non",
    close: "Fermer",
    save: "Enregistrer",
    delete: "Supprimer",
    edit: "Modifier",
    view: "Afficher",
    send: "Envoyer",
    next: "Suivant",
    previous: "Précédent",
    validations: "Validations",
    validating: "Validation en cours...",
    photo: "Photo",
    qrCode: "QR Code",
    list: "Liste",
    map: "Carte",
    seal: "Sceau",
    code: "Code",
    loadImages: "Charger l'image",
  },
  camera: {
    instructions: {
      title: "Préparez le sceau",
      description:
        "Pointez la caméra vers le sceau et attendez. Le système le reconnaîtra et prendra automatiquement la photo.",
      focusDesc: "Gardez votre téléphone immobile pendant la prise de la photo.",
      button: "Commencer",
    },
    scanning: "Scan en cours...",
    positionQRHere: "Positionnez le QR code ici",
    scanningAutomatically: "Scan automatiquement",
    takePhoto: "Prendre une photo",
    selectFile: "Choisir une image",
    retake: "Reprendre",
    switchCamera: "Changer de caméra",
    positionSealHere: "Alignez le sceau ici",
    tapScreen: "Touchez l'écran pour faire la mise au point",
    tapToTakePhoto: "Touchez l'écran pour prendre la photo",
    guidanceDetected: "Gardez votre téléphone immobile et patientez.",
    guidancePreparing: "Préparation de la caméra...",
    guidanceFind: "Pointez la caméra vers le sceau.",
    guidanceCloser: "Rapprochez la caméra du sceau.",
    guidanceFarther: "Éloignez un peu la caméra.",
    guidanceCenter: "Centrez le sceau.",
    guidanceHold: "Parfait. Ne bougez plus.",
    guidanceCapturing: "Capture de la meilleure photo...",
    waitingWhileCameraLoads:
      "Veuillez patienter pendant le chargement de la caméra...",
    error: "Erreur de la caméra",
    permissionDenied:
      "Permission d'accès à la caméra refusée. Veuillez autoriser l'accès à la caméra.",
    cameraNotFound:
      "Aucune caméra trouvée. Vérifiez que votre appareil dispose d'une caméra disponible.",
    accessError: "Erreur lors de l'accès à la caméra. Veuillez réessayer.",
    loadingTimeout:
      "La caméra met trop de temps à se charger. Vérifiez vos permissions.",
    capturedPhoto: "Numéro de série capturé",
    orientation: {
      portraitRecommended: "Mode portrait recommandé",
      landscapeRecommended: "Mode paysage recommandé",
      rotateToPortrait:
        "Tournez votre appareil en mode portrait pour une meilleure expérience de capture.",
      rotateToLandscape:
        "Tournez votre appareil en mode paysage pour une meilleure expérience de capture.",
      continueAnyway: "Continuer malgré tout",
    },
    errorValidatingSeal: "Erreur lors de la validation du sceau",
    errorSendingPhoto: "Erreur lors de l'envoi de la photo",
    errorValidatingSealDescription:
      "Une erreur s'est produite lors de la validation du sceau. Veuillez réessayer.",
    errorProcessingImage:
      "Une erreur est survenue lors du traitement de votre image. Veuillez réessayer.",
    aiValidationTitle: "L'IA analyse votre sceau",
    aiValidationDescription:
      "Nous vérifions la photo et les éléments de sécurité. Le résultat s'affichera automatiquement.",
    aiValidationPhoto: "Photo capturée",
    aiValidationStatus: "Analyse en cours",
    aiValidationWait: "Cela peut prendre quelques instants.",
    qrCodeNotFound: "QR code introuvable",
    qrCodeNotFoundWithEntry:
      "Le QR code du sceau n'a pas pu être identifié. Assurez-vous que le sceau est visible, bien éclairé et centré sur la photo.",
    qrCodeNotFoundGeneric:
      "Un QR code valide n'a pas pu être identifié dans l'image. Assurez-vous que le QR code est visible, bien éclairé et centré sur la photo.",
  },
  tutorial: {
    qrTutorial: {
      title: "Vérification de l’authenticité du sceau",
      description:
        "Pour continuer, prenez une photo du sceau. L’intelligence artificielle validera les éléments de sécurité.",
      button: "Cliquez ici pour prendre la photo",
    },
    photoStep: {
      step1: "Utilisez le même sceau que celui du QR Code scanné;",
      step2: "Photographiez un seul sceau;",
      step3: "Centrez le sceau sur l’écran;",
      step4: "Ne bougez pas le téléphone lors de la prise de photo;",
      step5:
        "Veuillez patienter pendant que l'intelligence artificielle effectue la validation;",
    },
    navigation: {
      previous: "Précédent",
      next: "Suivant",
      readQr: "Lire le QR Code",
    },
    modal: {
      title: "Préparez votre caméra",
      description: "Vous êtes maintenant prêt à scanner le QR Code du sceau !",
      button: "Allons scanner !",
      autoRedirect: "Redirection automatique dans 5 secondes...",
    },
  },
  securityAlert: {
    title: "Alerte de sécurité",
    potentiallyFake: "Sceau potentiellement faux !",
    description:
      "Le code unique ne correspond pas à la valeur attendue, ce qui peut indiquer une contrefaçon du sceau.",
    question:
      "Souhaitez-vous continuer et enregistrer cette vérification comme invalide ?",
    confirmIrregularity: "Confirmer l'irrégularité",
  },
  errorDisplay: {
    geolocationRequired: "Géolocalisation requise",
    sealNotFound: "Sceau introuvable",
    verificationError: "Erreur de vérification",
    geolocationInstructions: {
      title: "Comment activer la géolocalisation :",
      step1: "• Cliquez sur l'icône de localisation dans la barre d'adresse",
      step2: '• Sélectionnez "Autoriser" pour ce site',
      step3: "• Rechargez la page après avoir autorisé",
    },
    tryAgain: "Réessayer",
    backToHome: "Retour à l'accueil",
    noResults: "Aucun résultat trouvé",
    noValidations: "Aucune validation trouvée",
  },
  addressInfo: {
    title: "Adresse",
    street: "Rue",
    number: "Numéro",
    neighborhood: "Quartier",
    city: "Ville",
    state: "État",
    zipCode: "Code postal",
  },
  clientInfo: {
    title: "Informations client",
    cnpj: "CNPJ",
    name: "Nom",
    phone: "Téléphone",
    email: "E-mail",
  },
  hashVerification: {
    title: "Vérification du code unique",
    description:
      "Comparez le code unique ci-dessous avec celui imprimé sur le sceau",
    howToVerify:
      "Comment vérifier : Comparez caractère par caractère le code ci-dessous avec le code imprimé sur le sceau.",
    doesNotMatch: "Ne correspond pas",
    matches: "Oui, correspond",
    processing: "Traitement...",
    validating: "Validation en cours...",
  },
  loading: {
    validatingSeal: "Validation du sceau en cours...",
  },
  geoProtectRoute: {
    title: "Obtention de votre localisation",
    description:
      "Nous avons besoin de votre localisation pour vérifier les sceaux. Cela peut prendre quelques secondes.",
    loading: "Chargement de la localisation...",
  },
  errorsDisplay: {
    geolocationRequired: "Géolocalisation requise",
    sealNotFound: "Sceau non trouvé",
    verificationError: "Erreur de vérification",
    howToEnableGeolocation: "Comment activer la géolocalisation :",
    step1: "Cliquez sur l’icône de localisation dans la barre d’adresse",
    step2: 'Sélectionnez "Autoriser" pour ce site',
    step3: "Rechargez la page après avoir autorisé",
    retry: "Réessayer",
    backHome: "Retour à l’accueil",
  },
  errorBoundary: {
    title: "Une erreur inattendue s'est produite",
    description: "Une erreur s'est produite أثناء le chargement de cette page.",
    reload: "Recharger la page",
  },
  qrCodePage: {
    sealModal: {
      alignSeal: "Alignez le sceau dans la zone indiquée",
      title: "Sceau non identifié",
      lightingTitle: "Éclairage",
      lightingDesc: "Évitez les ombres et les reflets sur le sceau.",
      framingTitle: "Cadrage",
      framingDesc: "Centrez le sceau dans le cadre.",
      focusTitle: "Mise au point",
      focusDesc: "Faites la mise au point avant de prendre la photo.",
      usedSealTitle: "Correspondance",
      usedSealDesc: "Utilisez le même sceau que le QR Code",
      button: "Prendre une nouvelle photo",
    },
    centerSealAlert: "Centrez le sceau dans la zone indiquée",
    hashDoesNotMatch:
      "Le numéro du sceau ne correspond pas à notre base de données. Veuillez vérifier que vous utilisez le même sceau que le QR Code scanné.",
    seeAllSecurityItems: "Voir tous les éléments de sécurité",
    experienceAR: "Essayez la réalité augmentée",
    info: "Le numéro identifié sur la photo correspond à l’enregistrement de la base de données.",
    clickSealToCheck:
      "Cliquez sur le sceau pour vérifier les éléments de sécurité",
    uniqueCodeValidated: "Code unique validé avec succès",
    uniqueCodeDoesNotMatch: "Le code unique ne correspond pas",
    capColor: "couleur du couvercle",
    product: "Produit",
    productInfo: "Informations sur le produit",
    serial: "Série :",
    serialNotFound: "Série introuvable",
    hash: "Hash",
    importer: "Importateur :",
    batch: "Lot :",
    uniqueCode: "Code unique :",
    validated: "✓ Validé",
    takePhoto: "Prendre une photo",
    securityItems: {
      config: {
        useArrows: "Utilisez les flèches ou faites glisser pour naviguer",
        goToItem: "Aller à l'élément",
        noSecurityItems: "Aucun élément de sécurité disponible pour le moment.",
      },
    },
    verificationResult: "Résultat de la Vérification",
    qrCodeVerification: "Vérification du QR Code",
    suspicious:
      "Vérifiez s'il existe des signes visibles de falsification ou d'incohérences, puis contactez le fournisseur ou le fabricant responsable du produit acheté.",
    validQrCodeDescription:
      "Ce QR Code semble valide, cependant, analysez les éléments de sécurité avec l'intelligence artificielle pour valider l'authenticité du sceau !",
    authenticityAnalysis: "Analyse d'authenticité du sceau INMETRO",
    imageAnalyzed: "Image Analysée",
    qrCodeValid: "QR Code Valide",
    elements: "éléments",
    detectedElements: "Éléments Détectés",
    securityItemsTitle: "Éléments de Sécurité",
    explanation: "Explication",
    dataComparison: "Comparaison des Données",
    dbSerial: "Numéro de Série de la Base de Données",
    photoSerial: "Numéro de Série de la Photo",
    confidence: "Confiance",
    backButton: "Retour",
  },
  reportModal: {
    title: "Signaler une irrégularité",
    description:
      "Indiquez où vous avez trouvé ce sceau suspect et joignez une photo",
    locationLabel: "Lieu de l'irrégularité",
    locationPlaceholder: "Ex : Pharmacie ABC, Rue des Fleurs, 123",
    locationHint:
      "Soyez précis : nom de l'établissement, adresse ou point de repère",
    photoLabel: "Photo du sceau irrégulier",
    photoHint: "La photo aidera notre équipe à mieux identifier l'irrégularité",
    takePhoto: "Prendre une photo",
    gallery: "Galerie",
    newPhoto: "Nouveau",
    positionSealHere: "Positionnez le sceau ici",
    ensureReadable: "Assurez-vous qu'il est lisible",
    sealReportedAsFake: "Sceau signalé comme FAUX :",
    sealIdentifiedAsFake:
      "Ce sceau a été identifié comme potentiellement faux en raison de la non-correspondance du code unique.",
    reportSent: "Signalement envoyé !",
    investigationMessage: "Notre équipe enquêtera sur l'irrégularité.",
    protocol: "Protocole :",
    errorSending: "Erreur lors de l'envoi du signalement",
    tipsForBetterPhoto: "Conseils pour une meilleure photo :",
    tips: {
      lighting: "• Assurez-vous que le sceau est bien éclairé",
      reflections: "• Évitez les reflets et les ombres",
      stability: "• Maintenez la caméra stable",
      sealSize: "• Le sceau devrait occuper la majeure partie de la photo",
      readability: "• Vérifiez que tous les codes sont lisibles",
    },
    sending: "Envoi...",
    report: "Signaler",
  },
  additionalInfo: {
    title: "Informations supplémentaires",
    description:
      "Pour plus de détails sur la validation ou pour signaler des problèmes, contactez le support technique via le site de Mistral.",
  },
  validations: {
    title: "Carte des validations",
    subtitle:
      "Visualisez toutes les validations de sceaux effectuées dans le système.",
    filters: {
      title: "Filtres",
      description: "Recherchez par adresse, numéro de série ou enregistrement",
      placeholder: "Rechercher des validations...",
      status: {
        valid: "Validés",
        invalid: "Rejetés",
        pending: "En cours d'analyse",
      },
      type: {
        title: "Type de validation",
        qrcode: "QR Code",
        photo: "Photo",
      },
    },
    list: {
      title: "Validations",
      loading: "Chargement des validations...",
      empty: "Aucune validation trouvée",
      found: "validations trouvées",
      view: {
        list: "Liste",
        map: "Carte",
      },
    },
    details: {
      title: "Détails",
      date: "Date",
      time: "Heure",
      serialNumber: "Numéro de série",
      registerNumber: "Numéro d'enregistrement",
      address: "Adresse complète",
      addressUnavailable: "Adresse non disponible",
      photo: {
        title: "Photo du sceau",
        none: "Aucune photo disponible",
        capturedAt: "Capturé le : {{date}} à {{time}}",
      },
      viewDetails: "Voir les détails",
      close: "Fermer les détails",
    },
    map: {
      error: {
        title: "Erreur lors du chargement de la carte",
        description:
          "Vérifiez votre connexion Internet ou réessayez plus tard.",
      },
      loadingMore: "Chargement de plus de validations...",
    },
  },
  internalDashboard: {
    header: {
      title: "Tableau d'administration",
      subtitle: "Système interne Inmetro",
      systemOnline: "Système en ligne",
      signOut: "Se déconnecter",
    },
    welcome: {
      title: "Bienvenue dans le système interne",
      subtitle: "Choisissez une des options ci-dessous pour continuer",
    },
    cards: {
      mapAndQueries: {
        title: "Carte et requêtes",
        description:
          "Accédez à la carte interactive et effectuez des requêtes de validation de sceaux",
        button: "Accéder à la carte",
      },
      history: {
        title: "Historique",
        description:
          "Consultez l'historique complet des requêtes et des validations effectuées",
        button: "Voir l'historique",
      },
      userManagement: {
        title: "Utilisateurs internes",
        description:
          "Gérez les utilisateurs internes du système – créer, modifier et supprimer des accès",
        button: "Gérer les utilisateurs",
      },
    },
  },
  loginPage: {
    title: "Connectez-vous à votre compte",
    fields: {
      email: {
        label: "Email",
        placeholder: "Entrez votre email",
      },
      password: {
        label: "Mot de passe",
        placeholder: "Entrez votre mot de passe",
      },
    },
    links: {
      forgotPassword: "Mot de passe oublié",
    },
    rememberMe: "Se souvenir de moi",
    buttons: {
      signIn: "Se connecter",
      signingIn: "Connexion en cours...",
    },
    screenReader: {
      hidePassword: "Masquer le mot de passe",
      showPassword: "Afficher le mot de passe",
    },
    errors: {
      emailRequired: "L'email est requis",
      emailInvalid: "Email invalide",
      cpfInvalid: "Le CPF doit contenir 11 chiffres",
      passwordRequired: "Le mot de passe est requis",
      passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères",
      invalidCredentials: "Email ou mot de passe incorrect",
      serverError: "Erreur interne du serveur",
    },
    toasts: {
      loginError: "Erreur lors de la connexion. Vérifiez vos identifiants.",
      loginSuccess: "Connexion réussie !",
      serverError: "Erreur interne du serveur. Veuillez réessayer.",
    },
  },
  queryPage: {
    title: "Comparaison d'entrées",
    sections: {
      imageComparison: "Comparaison d'images",
      comparisonSummary: "Résumé de la comparaison",
      detailedAnalysis: "Analyse détaillée",
    },
    sealOwner: {
      title: "Données de l'entreprise",
      description: "Informations sur l'entreprise responsable du sceau.",
      cnpj: "CNPJ",
      companyName: "Nom de l'entreprise",
      productName: "Nom du produit",
      notProvided: "Non renseigné",
    },
    sources: {
      database: "Numéro de série attendu",
      photo: "Photo",
    },
    fields: {
      serialNumber: "Numéro de série",
      publicHash: "Hash public",
    },
    status: {
      match: "Conforme",
      mismatch: "Divergent",
      partial: "Partiel",
      missing: "Non détecté",
      discrepancyDetected: "Divergence détectée",
      detected: "Détecté",
    },
    messages: {
      noImage: "Pas d'image",
      notFound: "Non trouvé",
      valueDiffers:
        "Cette valeur diffère de celle enregistrée dans la base de données.",
    },
    buttons: {
      back: "Retour",
      validateAnother: "Valider un autre sceau",
    },
    emptyState: {
      title: "Aucun enregistrement trouvé",
      description: "Il n'y a pas d'entrées disponibles pour cette requête.",
      button: "Retour",
    },
    notFound: {
      title: "Requête introuvable",
      description: "Les données pour cette requête n'ont pas pu être trouvées.",
      button: "Retour",
    },
    aiAnalysis: {
      title: "Analyse IA",
      badge: "Réponse générée par l'IA",
      noAnalysis: "Impossible de générer une analyse pour ces entrées.",
      loading: {
        title: "Analyse des entrées...",
        description:
          "Notre IA compare les données et génère des informations sur les entrées",
      },
      error: {
        title: "Erreur d'analyse",
        description:
          "Impossible de générer l'analyse. Veuillez réessayer plus tard.",
        button: "Réessayer",
      },
      disclaimer:
        "Cette analyse est générée automatiquement et peut ne pas refléter toutes les nuances des données.",
    },
    dataComparisonCard: {
      title: "Vérification du numéro de série",
      database: "Base de données",
      found: "Trouvé",
      photo: "Photo (OCR)",
      detected: "Détecté",
      notDetected: "Non détecté",
      notFound: "Non trouvé",
      mismatchTitle: "Numérotation divergente",
      highConfidenceMessage:
        "L'analyse indique une forte confiance que le sceau est authentique (confiance : {confidence} %), cependant le numéro détecté sur la photo ne correspond pas au numéro enregistré dans la base de données. Cela peut indiquer un sceau légitime appliqué incorrectement, une possible altération ou une photo prise d'un autre sceau.",
      lowConfidenceMessage:
        "Le numéro détecté sur la photo ne correspond pas au numéro enregistré dans la base de données. De plus, la confiance de détection est faible ({confidence} %), ce qui peut indiquer une difficulté de lecture ou des problèmes avec le sceau.",
      partialMessage:
        "Le numéro de série de la base de données a été trouvé, mais il n'a pas été possible de lire le numéro sur la photo. Cela peut se produire si l'image est de mauvaise qualité ou si le sceau est endommagé.",
    },
    explanationSection: {
      title: "Comment interpréter les résultats ?",
      levels: {
        high: {
          range: "80% - 100%",
          trust: "Haute confiance",
          description: "L’élément a été identifié avec confiance.",
        },
        medium: {
          range: "60% - 79%",
          trust: "Confiance moyenne",
          description:
            "Il y a des indices de l’élément, mais une vérification supplémentaire est recommandée.",
        },
        low: {
          range: "0% - 59%",
          trust: "Faible confiance",
          description: "L’élément n’a pas été confirmé dans cette capture.",
        },
      },
      footer:
        "Notre intelligence artificielle analyse l’image pour détecter les éléments de sécurité du sceau INMETRO. Le pourcentage indique le niveau de certitude que chaque élément a été correctement identifié.",
    },
    verdictCard: {
      authentic: {
        title: "Sceau authentique",
        subtitle:
          "Les éléments de sécurité du sceau ont été authentifiés avec succès!",
      },
      warning: {
        title: "Vérification non concluante",
        subtitle: "Certains éléments nécessitent une attention",
      },
      suspicious: {
        title: "Sceau suspect",
        subtitle: "Impossible de confirmer l’authenticité",
      },
      aiBadge: "Analyse par IA",
      overallConfidence: "Confiance globale",
    },
  },
  notFoundPage: {
    title: "404",
    message: "Oups ! La page que vous recherchez n'existe pas.",
    backText: "Vous pouvez revenir à la",
    homeLink: "page d'accueil",
  },
  reportPage: {
    header: {
      badge: "Système de validation des sceaux",
      title: "Signalement d'irrégularités",
      subtitle:
        "Signalez des sceaux contrefaits ou irréguliers pour contribuer à la sécurité et à la conformité.",
      anonymousTitle: "Signalements anonymes",
      anonymousSubtitle: "Votre identité sera protégée",
      backButton: "Retour à la page d'accueil",
    },
    howToReport: {
      title: "Comment signaler",
      subtitle: "Suivez ces étapes pour déposer votre signalement",
      steps: {
        step1: {
          title: "Remplissez le formulaire",
          description:
            "Fournissez autant de détails que possible sur l'irrégularité constatée",
        },
        step2: {
          title: "Joignez des preuves",
          description:
            "Envoyez des photos claires du sceau suspect pour analyse",
        },
        step3: {
          title: "Indiquez vos coordonnées",
          description:
            "Vos coordonnées sont facultatives, mais elles aident le processus d'enquête",
        },
        step4: {
          title: "Suivez le processus",
          description:
            "Recevez des mises à jour sur l'avancement de votre signalement",
        },
      },
    },
    identifyingFakes: {
      title: "Identifier les sceaux falsifiés",
      subtitle: "Caractéristiques à vérifier",
      characteristics: {
        holographic: {
          title: "Éléments holographiques",
          description:
            "Vérifiez si le sceau possède un filigrane et des éléments holographiques changeant selon l'angle",
        },
        qrCode: {
          title: "QR Code fonctionnel",
          description:
            "Vérifiez si le QR code fonctionne et renvoie vers le site officiel du {{productName}}",
        },
        printQuality: {
          title: "Qualité d'impression",
          description:
            "Observez s'il y a des erreurs d'impression, une faible qualité graphique ou des couleurs incorrectes",
        },
        serialNumber: {
          title: "Numéro de série valide",
          description:
            "Vérifiez si le numéro de série est valide dans le système de consultation officiel",
        },
      },
      guideLink: "Voir le guide complet d'identification",
    },
    form: {
      title: "Formulaire de signalement",
      subtitle:
        "Remplissez les champs ci-dessous avec des informations sur l'irrégularité constatée.",
      steps: {
        information: "Informations",
        contact: "Contact",
        confirmation: "Confirmation",
        stepLabel: "Étape {{current}} sur {{total}}",
      },
      fields: {
        irregularityType: {
          label: "Type d'irrégularité",
          placeholder: "Sélectionnez le type d'irrégularité",
          options: {
            fake: "Sceau contrefait",
            tampered: "Sceau altéré",
            reused: "Sceau réutilisé",
            noSeal: "Produit sans sceau",
            other: "Autre",
          },
        },
        description: {
          label: "Description de l'irrégularité",
          placeholder: "Décrivez l'irrégularité en détail",
          hint: "Incluez des détails tels que les caractéristiques du sceau, les problèmes identifiés et d'autres informations pertinentes.",
        },
        location: {
          label: "Lieu",
          placeholder: "Où le sceau a été trouvé",
        },
        date: {
          label: "Date de l'incident",
        },
        image: {
          label: "Image du sceau",
          uploadText: "Cliquez pour télécharger",
          tips: {
            title: "Conseils pour une bonne photo :",
            lighting: "Bonne illumination, sans reflets",
            centered: "Sceau complet et centré",
            sharp: "Image nette, sans flou",
            format: "Formats : JPG, PNG (max. 5 Mo)",
          },
        },
        company: {
          label: "Entreprise/Établissement (optionnel)",
          placeholder: "Nom de l'entreprise ou de l'établissement",
          hint: "Indiquez le nom de l'établissement où le sceau a été trouvé.",
        },
        contact: {
          label: "Email de contact",
          placeholder: "votre@email.com",
          hint: "Votre email sera utilisé uniquement pour les mises à jour concernant ce signalement et ne sera pas partagé.",
        },
        terms: {
          label:
            "Je déclare que les informations fournies sont exactes et je suis conscient(e) des conséquences légales d'un faux signalement.",
        },
      },
      alerts: {
        optionalData:
          "Vos coordonnées sont optionnelles, mais elles facilitent l'enquête.",
        dataProtection: {
          title: "Protection des données",
          description:
            "Vos données personnelles sont protégées conformément à la réglementation applicable (ex. RGPD/LGPD) et utilisées uniquement pour l'enquête.",
        },
        falseReport: {
          title: "Attention",
          description:
            "Les signalements faux peuvent entraîner des poursuites. Veuillez fournir des informations exactes.",
        },
      },
      summary: {
        title: "Résumé du signalement",
        type: "Type :",
        location: "Lieu :",
        date: "Date :",
        contact: "Contact :",
        description: "Description :",
        attachedImage: "Image jointe :",
      },
      buttons: {
        back: "Retour",
        continue: "Continuer",
        submit: "Envoyer le signalement",
        submitting: "Envoi en cours... {{progress}}%",
      },
    },
    success: {
      title: "Signalement envoyé avec succès",
      subtitle:
        "Votre signalement a bien été enregistré et sera examiné par notre équipe.",
      protocol: "Protocole : #DEN-{{number}}",
      message:
        "Vous recevrez un email de confirmation avec les détails de votre signalement et pourrez suivre son statut via votre tableau de bord.",
      buttons: {
        dashboard: "Accéder au tableau de bord",
        home: "Retour à l'accueil",
      },
      help: {
        text: "Besoin d'aide ?",
        link: "Contactez le support",
      },
    },
  },
  tutorialPage: {
    header: {
      skipTutorial: "Passer le tutoriel",
      startCapture: "Commencer la capture",
      skipToCamera: "Passer à la caméra",
    },
    steps: {
      step1: {
        title: "Positionnement correct",
        subtitle:
          "Placez le sceau dans la zone délimitée sur l'écran de la caméra.",
        tips: {
          title: "Conseils :",
          center: "Centre le sceau dans la zone délimitée",
          parallel: "Gardez l'appareil parallèle au sceau",
          avoid: "Évitez les angles inclinés qui déforment l'image",
        },
      },
      step2: {
        title: "Éclairage adéquat",
        subtitle:
          "Assurez-vous qu'il y ait une bonne illumination pour capturer tous les détails du sceau.",
        examples: {
          good: "Bon exemple",
          bad: "Mauvais exemple",
          goodLabel: "Bonne illumination",
          badLabel: "Illumination insuffisante",
          correct: "Correct",
          incorrect: "Incorrect",
        },
        tips: {
          title: "Conseils :",
          naturalLight:
            "Utilisez des environnements bien éclairés, de préférence avec de la lumière naturelle",
          avoidShadows: "Évitez les ombres sur le sceau",
          avoidReflections:
            "Évitez les reflets directs qui peuvent masquer des détails importants",
        },
      },
      step3: {
        title: "Netteté et stabilité",
        subtitle:
          "Maintenez l'appareil stable et assurez-vous que l'image soit nette avant de capturer.",
        examples: {
          good: "Bon exemple",
          bad: "Mauvais exemple",
          sharp: "Net",
          blurry: "Flou",
        },
        tips: {
          title: "Conseils :",
          steadyHands: "Maintenez les mains stables lors de la prise de photo",
          waitFocus: "Attendez l'autofocus avant de capturer l'image",
          fullSeal:
            "Essayez de capturer l'intégralité du sceau avec tous les détails",
          avoidMovement: "Évitez les mouvements brusques pendant la capture",
        },
      },
    },
    navigation: {
      previous: "Précédent",
      next: "Suivant",
    },
    rotationModal: {
      title: "Tournez votre téléphone",
      description:
        "Pour une meilleure expérience de capture, nous recommandons d'utiliser la caméra en orientation paysage.",
      button: "Compris, allons-y !",
      autoRedirect: "Redirection automatique dans 5 secondes...",
    },
    welcomeModal: {
      title: "Tutoriel de validation",
      subtitle:
        "Apprenez à prendre des photos parfaites pour la validation des sceaux",
      available: {
        title: "Tutoriel disponible",
        description:
          "Souhaitez-vous voir un court tutoriel sur la meilleure façon de photographier le sceau ?",
      },
      bestResults: {
        title: "Meilleurs résultats",
        description:
          "Le tutoriel aide à garantir des photos nettes et des validations précises",
      },
      buttons: {
        skip: "Passer le tutoriel",
        start: "Voir le tutoriel",
      },
    },
  },
  privacyPolicyPage: {
    title: "Politique de Confidentialité",
    company: "PRIMI TECNOLOGIA LTDA",
    introP1:
      "PRIMI TECNOLOGIA LTDA PRIMI, dont le siège social est situé Estrada Rosa Scarpa, nº 65, Votuparim, Santana de Parnaíba, São Paulo – SP, Code Postal 06513-010, en conformité avec les exigences légales et engagée à fournir un excellent service à ses prospects, visiteurs, clients, anciens clients, fournisseurs, prestataires de services, anciens fournisseurs, anciens prestataires, utilisateurs, candidats, employés et anciens employés (TITULAIRES DE DONNÉES), établit par la présente sa Politique de Confidentialité.",
    introP2:
      "Par cette Politique, PRIMI vise à respecter les exigences légales de la Loi Fédérale nº 13.709/2018 (Loi Générale sur la Protection des Données - LGPD), du Code de Protection et de Défense du Consommateur (Loi Fédérale nº 8.078/1990) et du Cadre Civil de l'Internet (Loi Fédérale nº 12.965/2014), ainsi que leurs mises à jour et normes complémentaires, garantissant que dans toute interaction et traitement des données des TITULAIRES, il existe des processus solides et techniques qui consolident la Sécurité des Données et de l'Information.",
    introP3:
      "Non seulement par ses certifications de sécurité, PRIMI dispose d'une équipe dédiée et formée pour protéger toutes les données collectées et agit avec la transparence de cette politique pour assurer aux TITULAIRES que leurs données sont protégées contre les fuites et violations, et les utiliser strictement aux fins consenties.",
    introP4:
      "Nous collectons et utilisons certaines données personnelles de nos utilisateurs, en tant que contrôleurs et opérateurs de ces données personnelles, étant soumis à toutes les dispositions normatives associées.",
    introP5:
      "PRIMI est responsable du Traitement des Données Personnelles des TITULAIRES et détermine les finalités et moyens de traitement via cette politique disponible sur notre site web, canaux et plateformes.",
    introP6:
      "Ainsi, par ces termes, les TITULAIRES donnent leur plein consentement au Traitement de leurs Données Personnelles.",
    section1: {
      title: "I. DONNÉES COLLECTÉES ET MODE DE COLLECTE",
      p1: "Les données collectées par PRIMI, avec l'accord des TITULAIRES, sont les Données d'Inscription (Nom, CPF, téléphone, entre autres) ; Données d'Accès (mots de passe, entre autres) ; Informations Numériques et de Navigation (Cookies, entre autres) ; Données Financières (données de paiement, autres informations).",
      p2: "La collecte de ces données se fait directement auprès des TITULAIRES via les plateformes elles-mêmes ou indirectement par l'intermédiaire de tiers.",
      p3: "Concernant les informations et données fournies par les TITULAIRES, la collecte directe s'effectue via les plateformes numériques de PRIMI (Site, Plateforme Primi, Sceau Intelligent, centres d'appels, formulaires, chatbots, entre autres).",
      p4: "Concernant les informations et données obtenues par l'intermédiaire de tiers, PRIMI reçoit des données et informations par l'intermédiaire de tiers intermédiaires, par exemple sur les plateformes de recrutement, les organismes publics, y compris les systèmes d'information de crédit, entre autres.",
      p5: "Des informations et données peuvent également être obtenues automatiquement via les appareils utilisés par les TITULAIRES. Ces informations sont utilisées pour améliorer l'expérience des TITULAIRES sur nos plateformes et utilitaires, tels que les cookies, tags, balises pour le contrôle d'identité et de session, par exemple.",
      p6: "De plus, la collecte de données peut avoir lieu sur les réseaux sociaux (LinkedIn, Instagram, Facebook) et auprès d'organismes publics (Inmetro, Portail de la Transparence, entre autres).",
    },
    section2: {
      title: "II. TRAITEMENT - STOCKAGE ET PROTECTION DES DONNÉES",
      p1: "Les données des TITULAIRES sont protégées et sécurisées par les meilleures technologies, techniques et processus internes pour prévenir les fuites et violations.",
      p2: "PRIMI détient des certifications de sécurité telles que l'ISO 27001 – Sécurité de l'Information et la NBR 15540 – Sécurité Graphique, et adopte des processus physiques et numériques pour la protection de ses données, ainsi que les meilleures pratiques de sécurité en Technologies de l'Information.",
      p3: "PRIMI protège ses données par un accès restreint aux Données Personnelles, y compris l'accès électronique et physique avec protection par mot de passe, masquage des données, anonymisation, parmi d'autres techniques de protection des données.",
      p4: "De plus, PRIMI adopte une Politique de Sécurité de l'Information stricte, dont les processus sont constamment audités en interne et en externe ; ces processus préservent l'intégrité et la confidentialité des données traitées, notamment parce qu'ils guident et orientent les actions du personnel interne et des éventuels tiers responsables du traitement de ces données.",
      p5: "La durée de conservation des données personnelles est aussi longue que nécessaire pour leur utilisation, selon l'obligation légale de conservation respective, les besoins et l'intérêt légitime de PRIMI.",
    },
    section3: {
      title: "III. FINALITÉ DE LA COLLECTE DES DONNÉES",
      p1: "Toutes les données collectées par PRIMI ont plusieurs finalités, notamment mais sans s'y limiter :",
      list: [
        {
          label: "Pour l'élaboration de nos produits :",
          text: "dans la confection de matériaux, PRIMI peut utiliser les données reçues des clients et des organismes publics, étant des exigences nécessaires pour l'impression de sécurité ;",
        },
        {
          label:
            "Pour le respect de nos obligations légales et l'exercice régulier de nos droits :",
          text: "les données des TITULAIRES sont utilisées pour remplir les obligations légales envers les organismes publics et les entités réglementaires (ANPD, INMETRO, entre autres). Même après la fin de la relation avec PRIMI, les données resteront sous son contrôle, considérant que certaines données personnelles peuvent être nécessaires pour que PRIMI exerce ses droits garantis par la loi, notamment comme preuve dans des procédures judiciaires, administratives ou arbitrales ;",
        },
        {
          label:
            "Pour l'utilisation de nos plateformes numériques et services d'assistance :",
          text: "PRIMI peut utiliser les données des TITULAIRES pour améliorer et personnaliser nos plateformes selon leur profil d'utilisateur grâce à des techniques spécifiques ;",
        },
        {
          label:
            "Pour la réalisation d'actions Marketing et de Communications avec les TITULAIRES :",
          text: "PRIMI peut utiliser les données des TITULAIRES pour préparer des communications et des actions marketing spécifiques. Le traitement des données est également nécessaire pour l'interaction avec nos services ;",
        },
        {
          label: "Pour la prévention des fraudes et l'analyse de crédit :",
          text: "PRIMI peut utiliser les données des TITULAIRES pour l'analyse de profil dans le cadre de nos activités ;",
        },
        {
          label: "Pour répondre à l'intérêt légitime de PRIMI :",
          text: "PRIMI peut utiliser les données des TITULAIRES pour réaliser des études statistiques, créer des métriques et indicateurs, pour les processus de sélection, l'embauche de fournisseurs et prestataires, les campagnes produits et/ou offres.",
        },
      ],
    },
    section4: {
      title: "IV. PARTAGE DES DONNÉES PERSONNELLES",
      p1: "PRIMI ne partage les données personnelles qu'avec des tiers pour un intérêt légitime et avec les autorités publiques pour respecter les obligations légales et sous détermination légale et judiciaire.",
      p2: "Dans ce partage de données personnelles, PRIMI dispose de processus pour garantir que la partie réceptrice reçoive ces données de manière appropriée, garantissant la confidentialité du transfert. PRIMI effectue des transferts de données pouvant être internationaux, via des processus sécurisés avec des fournisseurs fiables.",
    },
    section5: {
      title: "V. DROITS ET DEVOIRS DES TITULAIRES DE DONNÉES",
      p1: "À tout moment, les TITULAIRES ont le droit de savoir sur le traitement de leurs données personnelles ; quelles données personnelles sont traitées ; à quelle fin elles sont traitées ; de demander et corriger des données incomplètes, inexactes ou obsolètes ; de demander l'anonymisation, le blocage ou la suppression des données qu'ils jugent excessives ; de demander la révision des données concernant leur intérêt ; de demander la suppression des données traitées avec consentement, sauf pour respecter une obligation légale ou un autre intérêt légitime de PRIMI ; de refuser le consentement - dans ce cas, PRIMI informera des conséquences du non-consentement.",
      p2: "Les TITULAIRES ont le droit de savoir comment PRIMI traite leurs données, avec une réponse obligatoire sous 15 jours en format complet ou immédiatement avec une réponse simplifiée.",
      p3: "Les données traitées des TITULAIRES peuvent inclure des informations sur la finalité du traitement, les catégories de données, les durées de conservation, et les entités avec lesquelles les données ont été partagées. Les TITULAIRES peuvent également demander la portabilité des données - sauf celles déjà anonymisées.",
      p4: "PRIMI recommande aux TITULAIRES de toujours maintenir la confidentialité de leur identifiant et mot de passe, et de ne jamais partager leurs données et informations personnelles avec des tiers. PRIMI ne peut être tenue responsable du partage inapproprié de ces données par les TITULAIRES eux-mêmes.",
      p5: "Les TITULAIRES doivent toujours fournir des informations véridiques lors de l'utilisation de nos produits et services, sous peine des sanctions légales applicables.",
    },
    section6: {
      title: "VI. CONTACT DU DÉLÉGUÉ À LA PROTECTION DES DONNÉES",
      p1: "Pour tout besoin de contact, exercer vos droits et clarifier vos doutes avec PRIMI, vous pouvez contacter directement le Délégué à la Protection des Données, Mme Victória Colombarolli Ferreira.",
      p2: "Contact :",
      email: "dpo@primi.com.br",
    },
    section7: {
      title: "VII. DISPOSITIONS FINALES",
      p1: "Enfin, PRIMI se réserve le droit de modifier cette politique et cet avis de confidentialité à tout moment, en les maintenant toujours à jour et disponibles sur",
      link: "https://primi.com.br/privacidade",
    },
    copyright: "© {year} Primi Tecnologia Ltda. Tous droits réservés.",
  },
  termsOfUsagePage: {
    title: "Conditions Générales d'Utilisation",
    subtitle: "Plateforme Validador",
    introP1:
      "Les présentes Conditions Générales d'Utilisation définissent les règles générales du PORTAL S.I., mis à disposition via un portail électronique à l'adresse",
    introP1End: ", entre les parties suivantes :",
    introP2:
      "Primi Tecnologia Ltda. (PRIMI), dont le siège social est situé Estrada Rosa Scarpa, n° 65, Votuparim, Santana de Parnaíba, São Paulo – SP, Code Postal 06513-010.",
    introP3:
      "Et, d'autre part, la personne physique ou morale identifiée dans l'enregistrement du PORTAL S.I., ci-après dénommée UTILISATEUR. La lecture et l'acceptation du présent document impliquent l'acceptation des présentes Conditions Générales d'Utilisation du PORTAL S.I.",
    introP4:
      "Si vous n'acceptez pas une quelconque disposition des présentes Conditions, veuillez ne pas utiliser nos services. Ces Conditions ne s'appliquent pas aux sites Internet tiers et/ou aux services et produits fournis par des tiers, même s'ils ont un lien avec le PORTAL S.I., sont annoncés ou diffusés sur le PORTAL S.I., ou ont été consultés de quelque manière que ce soit via le PORTAL S.I.",
    introP5:
      "Le PORTAL S.I. se réserve le droit de modifier à tout moment les présentes Conditions Générales d'Utilisation afin de refléter adéquatement les services, politiques et pratiques mis à jour.",
    section1: {
      title: "I. SERVICES ET DISPOSITIONS GÉNÉRALES",
      p1: "Le PORTAL S.I. est une plateforme gratuite destinée à la recherche d'informations et de procédures concernant l'originalité, la provenance et l'adéquation des imprimés et dispositifs de sécurité, selon les critères établis dans les présentes Conditions.",
      p2: "La proposition du PORTAL S.I. est exclusivement d'informer et d'orienter les citoyens de manière simple, facile et transparente sur l'adéquation des sceaux de sécurité.",
      p3: "L'UTILISATEUR déclare et reconnaît que toute consultation effectuée sur le PORTAL S.I. sera réalisée en considération exclusive des bases de données qu'il a lui-même produites, le PORTAL S.I. n'étant pas responsable des erreurs de résultat provenant d'informations incomplètes, d'informations erronées, d'erreurs de procédure ou de défaillances de l'équipement de l'UTILISATEUR.",
      p4: "En ce sens, le PORTAL S.I. ne garantit en aucun cas qu'une consultation détermine si le sceau consulté est original ou faux, l'UTILISATEUR ayant toujours l'obligation de vérifier les informations contenues dans le sceau, de demander une analyse physique du sceau auprès du PORTAL S.I. ou de demander conseil auprès des autorités de contrôle.",
      p5: "De nouveaux types de questions et d'activités peuvent être inclus à tout moment, compte tenu de la nécessité, de la pertinence et de la disponibilité de ces informations.",
    },
    section2: {
      title: "II. DÉFINITIONS",
      p1: "Les définitions sont contenues dans la Politique de Confidentialité de PRIMI.",
    },
    section3: {
      title: "III. PROPRIÉTÉ INTELLECTUELLE",
      p1: "Tout le contenu, les matériaux et les services trouvés sur le PORTAL S.I. (textes, images, audio, technologie, logos, slogans, marques, expressions publicitaires, domaines, noms commerciaux, œuvres intellectuelles), ainsi que les logiciels qui permettent les activités, sont la propriété exclusive de PRIMI, qui détient tous les droits d'auteur, licences et droits de propriété intellectuelle, de marque ou de brevet y afférents. Toute violation des droits de propriété intellectuelle par l'UTILISATEUR entraînera sa responsabilité directe et personnelle pour les actes commis, conformément à la loi et avec l'application des sanctions civiles et pénales applicables.",
      p2: "L'UTILISATEUR s'engage à ne pas reproduire, dupliquer, copier ou exploiter les services fournis, les logiciels utilisés et/ou les matériaux mis à disposition par PRIMI, à des fins non expressément autorisées dans les présentes conditions, sans son autorisation écrite. L'utilisation de l'ingénierie inverse par l'UTILISATEUR est également interdite.",
    },
    section4: {
      title: "IV. DURÉE, RÉSILIATION ET MODIFICATION DES CLAUSES",
      p1: "Les présentes Conditions resteront en vigueur pour une durée indéterminée ou aussi longtemps que le PORTAL S.I. sera disponible. Le PORTAL S.I. se réserve toutefois le droit, à tout moment, sans frais ni préavis, de cesser ses activités ou de limiter l'utilisation de ses services.",
      p2: "Le PORTAL S.I. se réserve le droit de bloquer l'accès de l'UTILISATEUR et de résilier immédiatement les présentes Conditions, sans préavis, chaque fois qu'à son seul discrétion, il estime qu'il existe des indices d'utilisation frauduleuse ou illicite du PORTAL S.I. par l'UTILISATEUR. Cela inclut, entre autres, tout indice - à la seule discrétion subjective du PORTAL S.I. - que l'UTILISATEUR a fraudé ou enfreint le système de sécurité.",
    },
    section5: {
      title: "V. ABSENCE DE RESPONSABILITÉ DU PORTAL S.I.",
      p1: "L'UTILISATEUR reconnaît et accepte que, bien que le PORTAL S.I. fasse de son mieux pour fournir la recherche la plus précise sur les sceaux de sécurité des extincteurs, il ne peut garantir l'exactitude, l'efficacité ou l'adéquation des informations fournies.",
      p2: "L'UTILISATEUR doit assumer l'entière responsabilité et accepter tous les risques inhérents à l'utilisation du PORTAL S.I. Toute information liée ou disponible sur le PORTAL S.I., y compris les résultats de recherches effectuées, sont présentées dans la confiance et la condition que l'UTILISATEUR a fourni et rempli toutes les étapes de manière fidèle, et elles n'ont pas été créées pour répondre à des besoins spécifiques, ni pour guider l'UTILISATEUR sur le respect de la législation en vigueur, ou pour influencer négativement le processus d'achat ou le choix d'un fournisseur spécifique, et peuvent inclure des inexactitudes techniques, juridiques, réglementaires ou des erreurs typographiques.",
      p3: "Le PORTAL S.I. se réserve le droit d'ajouter, de supprimer ou de modifier ses fonctionnalités et ses champs d'application, en tout ou en partie, à tout moment, sans préavis.",
      p4: "Le PORTAL S.I. fera ses meilleurs efforts pour rester accessible de manière constante, ininterrompue et exempte d'erreurs ; cependant, le PORTAL S.I. ne sera pas responsable des dommages résultant d'une défaillance ou d'une interruption dans la fourniture des services disponibles.",
      p5: "Le PORTAL S.I. n'offre aucune garantie d'aucune sorte concernant les consultations effectuées. En ce sens, l'UTILISATEUR déclare être conscient et accepte que le PORTAL S.I. décline toute responsabilité pour toute garantie implicite ou non expressément prévue dans les présentes, y compris, sans limitation, toute garantie d'adéquation à un usage particulier.",
      p6: "Le PORTAL S.I. n'est pas responsable et n'offre aucune garantie quant à l'exactitude, l'efficacité, l'opportunité ou l'adéquation de toute information, contenu, produit ou service fourni par des tiers, y compris les hyperliens vers des pages tierces.",
      p7: "Le PORTAL S.I. ne garantit pas qu'il sera exempt d'erreurs et/ou qu'il sera disponible 24 (vingt-quatre) heures sur 24, 7 (sept) jours sur 7. Le PORTAL S.I. se réserve le droit de devenir indisponible pour la période nécessaire aux opérations de maintenance et/ou à la mise en œuvre d'améliorations.",
      p8: "Le PORTAL S.I. ne sera en aucun cas responsable des dommages indirects, des pertes de profits ou des pertes de données liées à son utilisation.",
    },
    section6: {
      title: "VI. CONDITIONS GÉNÉRALES",
      p1: "En utilisant le PORTAL S.I., l'UTILISATEUR accepte expressément toutes les clauses du présent instrument, ainsi que les activités qui existent et qui pourraient exister, les reconnaissant comme innocentes, saines, de bonne foi et non offensantes, acceptant ses règles, instructions et conditions contenues dans le site lui-même, de manière absolue et sans restriction, garantissant qu'il ne se sentira en aucune façon outragé, offensé ou lésé par celles-ci.",
      p2: "Si le PORTAL S.I. crée une activité que l'UTILISATEUR ne considère pas, d'une manière ou d'une autre, comme innocente, saine, de bonne foi ou non offensante, ou qui pourrait éventuellement l'offenser ou lui nuire, l'UTILISATEUR est obligé de cesser d'utiliser les services.",
      p3: "Toute réclamation judiciaire ou extrajudiciaire qui pourrait être déposée contre le PORTAL S.I. en raison de la violation ou de l'infraction d'une clause ou disposition du présent instrument obligera l'UTILISATEUR à répondre intégralement et, le cas échéant, à titre récursoire, de toutes les pertes et dommages causés au PORTAL S.I. et/ou à des tiers.",
      p4: "Les services et contenus disponibles sur les sites Web tiers relèvent de la seule et exclusive responsabilité du tiers. Vous reconnaissez et acceptez que le PORTAL S.I. ne garantit, n'approuve, n'assume et n'a aucune responsabilité concernant les produits, services ou sites Web de tiers.",
      p5: "Le PORTAL S.I. met à la disposition de l'UTILISATEUR un canal pour clarifier les doutes, suggestions et réclamations concernant les services fournis, via les canaux de contact mis à disposition dans la Politique de Confidentialité de PRIMI.",
    },
    section7: {
      title:
        "VII. CONFIDENTIALITÉ, SÉCURITÉ, COOKIES ET TRAITEMENT DES DONNÉES",
      p1: "Tous les éléments relatifs à la Confidentialité, à la Sécurité, aux Cookies et au Traitement des Données sont traités dans la Politique de Confidentialité de PRIMI.",
    },
    section8: {
      title: "VIII. DROIT APPLICABLE ET JURIDICTION",
      p1: "Les présentes conditions sont régies uniquement et exclusivement par les lois de la République fédérative du Brésil, et tout litige juridique découlant de leur interprétation ou application sera jugé par les tribunaux brésiliens, avec élection du for de la Capitale de l'État de São Paulo, quelque privilégié qu'un autre soit ou puisse devenir.",
    },
    copyright: "© {year} Primi Tecnologia Ltda. Tous droits réservés.",
  },
  cookieConsentBanner: {
    description:
      "Nous utilisons des cookies pour vous aider à naviguer sur notre site et améliorer nos services. En continuant à naviguer, vous acceptez nos Conditions d'Utilisation et notre",
    privacyLink: "Politique de Confidentialité.",
    descriptionSuffix: "",
    acceptAll: "Accepter tous les cookies",
    rejectNonEssential: "Refuser les cookies non essentiels",
  },
};
